import { Checkbox } from 'ui/checkboxV2';
import { CheckboxGroupContainer, CheckboxContainer } from './CheckboxGroup.styled';
import { CheckboxGroupProps, Direction, Type } from './types';

export const CheckboxGroup = ({
  isDisabled = false,
  direction = Direction.Vertical,
  type = Type.Default,
  name,
  options,
  ...props
}: CheckboxGroupProps) => {
  return (
    <CheckboxGroupContainer
      $direction={direction}
      data-test={`checkbox-group-${name}`}
      disabled={isDisabled}
      name={name}
      {...props}
    >
      {options.map(({ label, id, hasError, ...optionProps }, i) => {
        const optionIsDisabled = isDisabled || optionProps.isDisabled;
        return (
          <CheckboxContainer
            $disabled={optionIsDisabled}
            $error={hasError}
            $status={optionProps.status}
            $type={type}
            key={id || i}
          >
            <Checkbox
              data-test="checkboxGroup-checkbox"
              {...optionProps}
              isDisabled={optionIsDisabled}
              label={label}
            />
          </CheckboxContainer>
        );
      })}
    </CheckboxGroupContainer>
  );
};
